import { request } from "../_helpers/Auth";

const namespace = "/api";

export const CreateAdminAccount = (payload) => {
    return request({
        url: namespace + "/admin",
        method: "post",
        data: payload,
    });
};

export const LoginAccount = (payload) => {
    return request({
        url: "api/login",
        method: "post",
        data: payload,
    });
};

export const LogoutAccount = () => {
    return request({
        url: "api/logout",
        method: "get",
    });
};

export const AskResetPassword = (payload) => {
    return request({
        url: namespace + "/user/password/ask_reset",
        method: "post",
        data: payload,
    });
};

export const ResetPassword = (payload) => {
    return request({
        url: namespace + "/user/password/change",
        method: "post",
        data: payload,
    });
};

export const VerifyToken = (token) => {
    return request({
        url: namespace + `/email/verify/${token}`,
        method: "get",
    });
};

export const GetInvoices = () => {
    return request({
        url: namespace + "/invoices",
        method: "get",
    });
};

export const getUserInfo = () => {
    return request({
        url: namespace + "/user",
        method: "get",
    });
};

export const getUsers = () => {
    return request({
        url: namespace + "/users",
        method: "get",
    });
};

export const getUser = (_id) => {
    return request({
        url: namespace + "/user/" + _id,
        method: "get",
    });
};

export const editUserInfos = (payload, id) => {
    return request({
        url: namespace + "/user/infos/" + id,
        method: "post",
        data: payload,
    });
};

export const getUserCheckingRules = (user_id) => {
    return request({
        url: namespace + "/user/" + user_id + "/checking-rules",
        method: "get",
    });
};

export const updateUserCheckingRules = (user_id, rules) => {
    return request({
        url: namespace + "/user/" + user_id + "/checking-rules",
        method: "put",
        data: { rules },
    });
};

export const getUserEstablishments = (_id) => {
    return request({
        url: namespace + "/user/" + _id + "/establishments/",
        method: "get",
    });
};

export const getUserCategories = (_id) => {
    return request({
        url: namespace + "/user/" + _id + "/categories",
        method: "get",
    });
};

export const getUserProjects = (_id) => {
    return request({
        url: namespace + "/user/" + _id + "/projects",
        method: "get",
    });
};

export const getUserTeams = (_id) => {
    return request({
        url: namespace + "/user/" + _id + "/teams",
        method: "get",
    });
};

export const getUserBadgeuses = (_id) => {
    return request({
        url: namespace + "/user/" + _id + "/badgeuses",
        method: "get",
    });
};

export const attachUserBadgeuse = (user_id, badgeuse_id) => {
    return request({
        url: namespace + "/user/" + user_id + "/badgeuse/" + badgeuse_id,
        method: "post",
        data: {},
    });
};

export const detachUserBadgeuse = (user_id, badgeuse_id) => {
    return request({
        url: namespace + "/user/" + user_id + "/badgeuse/" + badgeuse_id,
        method: "delete",
        data: {},
    });
};

export const attachUserCategory = (user_id, category_id) => {
    return request({
        url: namespace + "/user/" + user_id + "/category/" + category_id,
        method: "post",
        data: {},
    });
};

export const detachUserCategory = (user_id, category_id) => {
    return request({
        url: namespace + "/user/" + user_id + "/category/" + category_id,
        method: "delete",
        data: {},
    });
};

export const attachUserProject = (user_id, project_id) => {
    return request({
        url: namespace + "/user/" + user_id + "/project/" + project_id,
        method: "post",
        data: {},
    });
};

export const detachUserProject = (user_id, project_id) => {
    return request({
        url: namespace + "/user/" + user_id + "/project/" + project_id,
        method: "delete",
        data: {},
    });
};

export const attachUserTeam = (user_id, team_id) => {
    return request({
        url: namespace + "/user/" + user_id + "/team/" + team_id,
        method: "post",
        data: {},
    });
};

export const detachUserTeam = (user_id, team_id) => {
    return request({
        url: namespace + "/user/" + user_id + "/team/" + team_id,
        method: "delete",
        data: {},
    });
};

export const addValidator = (user_id, validator_id) => {
    return request({
        url: namespace + "/user/" + user_id + "/validator/" + validator_id,
        method: "post",
        data: {},
    });
};

export const deleteValidator = (user_id, validator_id) => {
    return request({
        url: namespace + "/user/" + user_id + "/validator/" + validator_id,
        method: "delete",
        data: {},
    });
};

export const getPlanningUsersVisibles = (user_id) => {
    return request({
        url: namespace + "/user/" + user_id + "/planning/users_visibles",
        method: "get",
    });
};

export const getPlanningTeamsVisibles = (user_id) => {
    return request({
        url: namespace + "/user/" + user_id + "/planning/teams_visibles",
        method: "get",
    });
};